module.exports = __webpack_public_path__ + "static/media/res6.716ea797.png";